import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Users, BookOpen, Headphones, ShieldCheck } from 'lucide-react';

const WhyUsSection = () => {
  const { language } = useLanguage();
  const sv = language === 'sv';
  const features = [
    { icon: Users, title: sv ? 'Smågrupper (2–5)' : 'Small Groups (2–5)', desc: sv ? 'Personlig uppmärksamhet i varje lektion.' : 'Personal attention in every lesson.' },
    { icon: BookOpen, title: sv ? 'Certifierad tajweed-lärare' : 'Certified Tajweed Teacher', desc: sv ? '5+ års erfarenhet av koranundervisning.' : '5+ years of Quran teaching experience.' },
    { icon: Headphones, title: sv ? 'Online från hemmet' : 'Online from Home', desc: sv ? 'Bekvämt och flexibelt schema.' : 'Convenient and flexible schedule.' },
    { icon: ShieldCheck, title: sv ? 'Personlig undervisning' : 'Personal Teaching', desc: sv ? 'Anpassat tempo och individuell feedback.' : 'Adapted pace and individual feedback.' },
  ];
  return (
    <section className="py-20" style={{ backgroundColor: 'var(--bg-secondary)' }} data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
            {sv ? 'Varför välja oss' : 'Why Choose Us'}
          </h2>
          <p style={{ color: 'var(--text-secondary)' }} className="max-w-xl mx-auto text-sm">
            {sv ? 'Vi erbjuder en professionell och strukturerad väg till korrekt koranläsning.' : 'We offer a professional and structured path to correct Quran reading.'}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div key={i} className="pricing-card text-center !p-6" data-testid={`feature-${i}`}>
                <div className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center border border-gold/20 bg-gold/5">
                  <Icon size={22} className="text-gold" />
                </div>
                <h4 className="font-semibold text-sm mb-1.5" style={{ color: 'var(--text-primary)' }}>{f.title}</h4>
                <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
